<script setup lang="ts">
import type { TpgSelectEvent } from '@tpg/grammar-web';

export interface GrammarBreadcrumbItemProps {
  value?: string;
  label: string;
  selected?: boolean;
}

const props = withDefaults(defineProps<GrammarBreadcrumbItemProps>(), {
  value: '',
  selected: false,
});

const emit = defineEmits<{
  select: [event: TpgSelectEvent];
}>();

function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}
</script>

<template>
  <tpg-breadcrumb-item
    v-bind="props"
    @tpg-select="onSelect"
  />
</template>
